import classNames from 'classnames';
import React, { useReducer } from 'react';
import { useTranslation } from 'react-i18next';

import VehicleSelectV3 from '../../common/Components/VehicleSelectV3';
import Header from '../../main/components/Header';
import VehicleMaintenanceContracts from './VehicleMaintenanceContracts';

interface PacksLayoutState {
    vehcode: number;
}

const PacksLayout: React.FC = () => {
    const initialState: PacksLayoutState = {
        vehcode: -1,
    };
    const [state, setState]: [PacksLayoutState, React.Dispatch<any>] = useReducer(
        (oldState, newState) => ({ ...oldState, ...newState }), initialState,
    );

    const { t } = useTranslation();

    function onVehicleChange(event: any) {
        setState({
            vehcode: event,
        });
    }

    return (
        <React.Fragment>
            <div className={classNames(['grid-container', 'padding-bottom-4', 'service-inclusive'])}>
                <div className={classNames(['grid-x', 'grid-margin-x'])}>
                    <Header title={t(`contractsinvoices:maintenance.header`)} subtitle={t('contractsinvoices:maintenance.topText')} />
                    <div className={classNames(['cell', 'large-10', 'large-offset-1', 'columns'])}>
                        <div className={'tabs-content'} data-tabs-content="collapsing-tabs">
                            <div className={classNames(['tabs-panel', 'tabs-panel', 'is-active'])} id="panelViaturas">
                                <div className={classNames(['row', 'medium-unstack', 'dados-viaturas'])}>
                                    <div className={classNames(['columns', 'medium-12', 'margin-top-2'])}>
                                        <VehicleSelectV3 onChange={onVehicleChange} isMini={false} />
                                    </div>
                                    <div className={classNames(['columns', 'medium-12'])}>
                                        <hr />
                                    </div>
                                    <VehicleMaintenanceContracts vehcode={state.vehcode} vin={''} licensePlate={''} />
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </React.Fragment>
    );
};

export default PacksLayout;
